import { Spacing } from "@bonusx-global/bx-design-system";

export const MOBILE_CHILDREN_CONTAINER_SIDEBAR_PADDING = `${Spacing["2000"]} ${Spacing["1000"]} ${Spacing["2500"]}`;
